
import BaseAnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/base-animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";

export default class LandAnimateOverSymbolBehaviour extends BaseAnimateSymbolBehaviour {

    public behaviourName: string = "LandAnimateOver";

    /**
     * Same as AnimateOverBehaviour except for landing
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAnimation="win"] {string}
     */
    constructor(symbol: SymbolComponent, defaultAnimation: string = "win") {
        super(symbol, defaultAnimation);
    }

    public land(): Contract<void> {
        return this.animate("_land_over", ["land_over", this.defaultAnimation], true);
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }
}
